import { gql } from "graphql-tag";

/**
 * Fetches PromocodeCampaigns
 */
export const GET_CondfigPromocodeCampagins = gql`
  query GET_CondfigPromocodeCampagins(
    $condition: String!
    $skip: Int
    $limit: Int
  ) {
    promocodeCampaignList: PromoCodeConfigsList(
      where: $condition
      limit: $limit
      offset: $skip
    ) {
      posConfigId: PosConfigId
      pinned: Pinned
      position: Position
      PromoCodeCampaignRead {
        id: Id
        name: Name
        startDateTime: StartDateTime
        endDateTime: EndDateTime
        codes: PromoCodeList {
          id: Id
          code: Code
          codeUnique: CodeUnique
        }
        flatValue: FlatValue
        percentValue: PercentValue
        cancelled: Cancelled
        GroupRead {
          groupUuid: Uuid
        }
      }
    }
  }
`;
